export const style = {
  nonEditable: {
    cursor: `default`
  },
  title: {
    color: `black`
  },
  content: {
    color: `black`
  },
  edit: {
    color: `black`
  },
  nonEditableEdit: {
    opacity: 0
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/User/partials/UserEditor/partials/AccountDetails/style/ColorBlind/tableRow.js